import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'About Us', href: '/about' },
    { name: 'Reviews', href: '/reviews' },
    { name: 'Directions', href: '/directions' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      {/* Top Banner */}
      <div className="bg-red-700 text-white py-3">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <p className="text-lg font-medium">
              <span className="font-bold text-xl">Quality Auto Repairs</span> - Trusted by Passaic and Surrounding New Jersey Areas for Over 37 Years
            </p>
            <Link 
              to="/contact" 
              className="inline-flex items-center mt-2 px-4 py-2 bg-red-600 hover:bg-red-500 text-white rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-tools-fill mr-2"></i>
              Get Your Free Estimate Today
            </Link>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center cursor-pointer">
                <div className="flex items-center">
                  <div className="bg-red-700 text-white px-4 py-2 rounded-lg shadow-lg">
                    <div className="flex items-center space-x-2">
                      <i className="ri-tools-fill text-2xl"></i>
                      <div className="text-left">
                        <div className="text-xl font-bold leading-tight">SAGIL</div>
                        <div className="text-sm font-medium leading-tight">SERVICE</div>
                      </div>
                    </div>
                  </div>
                  <div className="ml-3 text-gray-700">
                    <div className="text-sm font-medium">Professional</div>
                    <div className="text-xs text-gray-500">Auto Repair</div>
                  </div>
                </div>
              </Link>
            </div>

            {/* Contact Info - Desktop */}
            <div className="hidden lg:flex items-center space-x-8">
              <div className="text-center">
                <div className="text-sm text-gray-600">Professional Auto Repair</div>
                <div className="flex items-center text-yellow-500">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <span className="ml-2 text-gray-900 font-medium">Quality Service</span>
                </div>
              </div>
              
              <div className="text-center">
                <a href="tel:(973) 472-0890" className="text-2xl font-bold text-gray-900 hover:text-red-700 cursor-pointer">
                  (973) 472-0890
                </a>
                <Link 
                  to="/contact" 
                  className="block mt-1 px-4 py-2 bg-red-700 hover:bg-red-600 text-white rounded-md transition-colors whitespace-nowrap cursor-pointer"
                >
                  Schedule Service
                </Link>
              </div>
            </div>

            {/* Mobile menu button */}
            <div className="lg:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 cursor-pointer"
              >
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
              </button>
            </div>
          </div>

          {/* Navigation - Desktop */}
          <nav className="hidden lg:block border-t border-gray-200">
            <div className="flex space-x-8 py-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive(item.href)
                      ? 'text-red-700 border-b-2 border-red-700'
                      : 'text-gray-700 hover:text-red-700'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </nav>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200">
            <div className="px-4 py-4 space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block px-3 py-2 text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    isActive(item.href)
                      ? 'text-red-700 bg-red-50'
                      : 'text-gray-700 hover:text-red-700 hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              
              <div className="pt-4 border-t border-gray-200">
                <a href="tel:(973) 472-0890" className="block text-xl font-bold text-gray-900 mb-2 cursor-pointer">
                  (973) 472-0890
                </a>
                <Link 
                  to="/contact" 
                  className="inline-block px-4 py-2 bg-red-700 hover:bg-red-600 text-white rounded-md transition-colors whitespace-nowrap cursor-pointer"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Schedule Service
                </Link>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
